import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { initializeFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCf-nANrcWX2417zxhCvysI0ST5bHOD2xE",
  authDomain: "streetwise-collective-app.firebaseapp.com",
  projectId: "streetwise-collective-app",
  storageBucket: "streetwise-collective-app.firebasestorage.app",
  messagingSenderId: "877667029211",
  appId: "1:877667029211:web:a865842dc09b65352ffcfe"
};

// App initialisieren
const app = initializeApp(firebaseConfig);

// Exporte für die App
export const auth = getAuth(app);
export const storage = getStorage(app);

// Firestore mit Long-Polling für maximale Stabilität in CodeSandbox
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});
